import React from 'react';
export function MechanismSection() {
  return <section className="py-24 bg-forest-900 text-forest-50 overflow-hidden relative" data-id="element-118">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 rounded-full bg-forest-800 opacity-50 blur-3xl" data-id="element-119"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 rounded-full bg-forest-800 opacity-50 blur-3xl" data-id="element-120"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-121">
        <div className="text-center mb-16" data-id="element-122">
          <span className="text-forest-300 tracking-widest uppercase text-sm font-semibold mb-4 block" data-id="element-123">
            The Unique Mechanism
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-white mb-6" data-id="element-124">
            The Microbial Pause & Flush (MPF) Framework
          </h2>
          <p className="text-xl text-forest-200 max-w-3xl mx-auto leading-relaxed" data-id="element-125">
            Instead of attacking your system, the MPF method uses a scripted
            biological sequence to gently reset your digestion.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-126">
          <div className="bg-forest-800/50 border border-forest-700 p-8 rounded-2xl backdrop-blur-sm" data-id="element-127">
            <div className="text-forest-300 font-serif text-5xl mb-4 opacity-50" data-id="element-128">
              01
            </div>
            <h3 className="text-xl font-medium text-white mb-3" data-id="element-129">
              Strategic Pause
            </h3>
            <p className="text-forest-200 leading-relaxed" data-id="element-130">
              We pause complex digestion for 24 hours to let your body's natural
              "clean-up crew" sweep out accumulated waste.
            </p>
          </div>

          <div className="bg-forest-800/50 border border-forest-700 p-8 rounded-2xl backdrop-blur-sm" data-id="element-131">
            <div className="text-forest-300 font-serif text-5xl mb-4 opacity-50" data-id="element-132">
              02
            </div>
            <h3 className="text-xl font-medium text-white mb-3" data-id="element-133">
              Osmotic Flush
            </h3>
            <p className="text-forest-200 leading-relaxed" data-id="element-134">
              We introduce specific osmotic liquids that attract and flush out
              the toxic water weight trapped in your tissues.
            </p>
          </div>

          <div className="bg-forest-800/50 border border-forest-700 p-8 rounded-2xl backdrop-blur-sm" data-id="element-135">
            <div className="text-forest-300 font-serif text-5xl mb-4 opacity-50" data-id="element-136">
              03
            </div>
            <h3 className="text-xl font-medium text-white mb-3" data-id="element-137">Gut Sealing</h3>
            <p className="text-forest-200 leading-relaxed" data-id="element-138">
              By hour 48, we "seal" the gut with easy-to-digest proteins so you
              stay flat, energized, and bloat-free through your event.
            </p>
          </div>
        </div>
      </div>
    </section>;
}